import { ListEventOptions, ListEventsResponseEntry } from '@shared/core/events'
import { UseQueryOptions, UseQueryResult } from 'react-query'
import { EventPreviewWithReminderData } from '../types/event.types'
import {
  isEventActivating,
  useHasRecentlyActivatedEvents,
  wasEventRecentlyActivated,
} from '../utils/recently-activated-events'
import { EventListData, useEventList } from './use-event-list'

const POLL_INTERVAL_MS = 3000

export type TabEventVisibility = (event: ListEventsResponseEntry) => boolean

export function computeShouldPoll(
  data: ListEventsResponseEntry[] | undefined,
  hasRecentlyActivated: boolean,
  isVisibleOnTab: TabEventVisibility = () => true,
): boolean {
  if (!hasRecentlyActivated) {
    return false
  }
  if (!data || data.length === 0) {
    return false
  }
  return data
    .filter(isVisibleOnTab)
    .some((event) =>
      isEventActivating(event as unknown as EventPreviewWithReminderData, wasEventRecentlyActivated(event.id)),
    )
}

export function useActivatingEventListPoll(
  params?: ListEventOptions,
  options?: UseQueryOptions<EventListData, unknown, EventListData>,
  isVisibleOnTab: TabEventVisibility = () => true,
): UseQueryResult<EventListData> {
  const hasRecentlyActivated = useHasRecentlyActivatedEvents()

  return useEventList(params, {
    ...options,
    refetchIntervalInBackground: false,
    refetchInterval: (data) =>
      computeShouldPoll(data, hasRecentlyActivated, isVisibleOnTab) ? POLL_INTERVAL_MS : false,
  })
}
